"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.map.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _report = require("@/api/report.api");
var _vuePropertyDecorator = require("vue-property-decorator");
var _BarChart = _interopRequireDefault(require("../BarChart.vue"));
var OrderTypeChart = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(OrderTypeChart, _Vue);
  var _super = (0, _createSuper2.default)(OrderTypeChart);
  function OrderTypeChart() {
    var _this;
    (0, _classCallCheck2.default)(this, OrderTypeChart);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "date", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "xAxisValue", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "legend", ["Doanh thu đơn cũ", "Doanh thu đơn mới", "Lợi nhuận đơn cũ", "Lợi nhuận đơn mới"]);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "series", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "$refs", void 0);
    return _this;
  }
  (0, _createClass2.default)(OrderTypeChart, [{
    key: "fetchData",
    value: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var query, res, data, series;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                query = {
                  date: this.date.to
                };
                _context.next = 3;
                return _report.reportApi.profitByOrderType(query);
              case 3:
                res = _context.sent;
                data = res.data;
                series = [];
                series.push({
                  name: "Doanh thu đơn cũ",
                  type: "bar",
                  barGap: 0,
                  stack: "Doanh thu",
                  itemStyle: {
                    color: "#d53e0a"
                  },
                  emphasis: {
                    focus: "series"
                  },
                  data: data.map(function (e) {
                    return e.old.totalPrice;
                  })
                });
                series.push({
                  name: "Doanh thu đơn mới",
                  type: "bar",
                  barGap: 0,
                  stack: "Doanh thu",
                  itemStyle: {
                    color: "#3066d0"
                  },
                  emphasis: {
                    focus: "series"
                  },
                  data: data.map(function (e) {
                    return e.new.totalPrice;
                  })
                });
                series.push({
                  name: "Lợi nhuận đơn cũ",
                  type: "bar",
                  stack: "Lợi nhuận",
                  barGap: 0,
                  itemStyle: {
                    color: "#57ce66"
                  },
                  emphasis: {
                    focus: "series"
                  },
                  data: data.map(function (e) {
                    return e.old.totalProfit;
                  })
                });
                series.push({
                  name: "Lợi nhuận đơn mới",
                  type: "bar",
                  stack: "Lợi nhuận",
                  barGap: 0,
                  itemStyle: {
                    color: "#ffbd35"
                  },
                  emphasis: {
                    focus: "series"
                  },
                  data: data.map(function (e) {
                    return e.new.totalProfit;
                  })
                });
                this.series = series;
                this.xAxisValue = data.map(function (e) {
                  return e.date;
                });
                _context.next = 14;
                return this.$nextTick();
              case 14:
                this.$refs.chart.initChart();
              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }()
  }]);
  return OrderTypeChart;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], OrderTypeChart.prototype, "date", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("date", {
  immediate: true
}), (0, _vuePropertyDecorator.Watch)("orderType")], OrderTypeChart.prototype, "fetchData", null);
OrderTypeChart = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    BarChart: _BarChart.default
  }
})], OrderTypeChart);
var _default = OrderTypeChart;
exports.default = _default;